import { Pipe, PipeTransform } from '@angular/core';

/**
 * Strip HTML from text.
 */
@Pipe({
  name: 'stripHtml'
})
export class StripHtmlPipe implements PipeTransform {

  /**
   * Strip HTML from text.
   *
   * @param value The text to be stripped from HTML.
   * @returns The text with all HTML stripped.
   */
  transform(value: string, keepBasicFormatting?: boolean): string {

    if (keepBasicFormatting) {
      value = value
        .replace(/<\/p><p>/g, '%RETURN%')
        .replace(/<\/p>\n<p>/g, '%RETURN%')
        .replace(/<\/p>\r<p>/g, '%RETURN%');
    }

    return value
      ? String(value).replace(/<[^>]+>/gm, '').replace(/%RETURN%/g, '<br><br>')
      : '';
  }
}
